import React from 'react';
import ReactDOM from 'react-dom';
import MainRouter from './routers';
import * as serviceWorker from './serviceWorker';
import {Provider} from 'react-redux';
import createStore from './redux';
import '@atlaskit/css-reset';
import {I18nextProvider} from 'react-i18next';
import i18n from './i18n';
// create our store
const store = createStore();

ReactDOM.render(
  <Provider store={store}>
    <I18nextProvider i18n={i18n}>
      <MainRouter />
    </I18nextProvider>
  </Provider>,
  document.getElementById('root')
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
